/**
 * Authentication Initialization Service
 * 
 * Handles authentication checks and user group verification.
 * Used by guards to determine if user has appropriate access.
 * Includes caching to prevent repeated API calls.
 */

import { Injectable } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { firstValueFrom, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthInitService {
  constructor(private calService: CalAngularService) { }
  async checkIfUserIsInGroup(groupName: string = 'Law - Substantiation AI - Admins'): Promise<boolean> {
    try {
      const isSignedIn = await firstValueFrom(this.calService.isUserSignedIn());
      if (!isSignedIn) {
        console.warn('User is not signed in');
        return false;
      }
      const isUserInGroup = await lastValueFrom(this.calService.isInGroup(groupName));
      return isUserInGroup;
    } catch (error) {
      console.error('Error checking user authentication:', error);
      return false;
    }
  }

}
